import {Repository} from './Repository';

export default class PushRepository extends Repository {
    constructor() {
        super();
        this.pushRequestPrefix = '/api/v1/push-alerts';
    }

    t

    postPush = (data) => {
        return this.getRequestPromise('post', this.pushRequestPrefix, data);
    }
    checkPush = (url, data) => {
        return this.getRequestPromise('post', this.pushRequestPrefix + `${url}`, data);
    }

    getPushes = (url) => {
        return this.getRequestPromise('get', this.pushRequestPrefix + `${url}`);
    }

    getPushDetail = (url) => {
        return this.getRequestPromise('get', this.pushRequestPrefix + `/${url}`);
    }

    getPushTranslateAll = (url) => {
        return this.getRequestPromise('get', this.pushRequestPrefix + `/${url}`);
    }

    getPushTranslate = (url) => {
        return this.getRequestPromise('get', this.pushRequestPrefix + `/${url}`);
    }

    putPush = (data) => {
        return this.getRequestPromise('put', this.pushRequestPrefix, data);
    }

    deletePush = (url) => {
        return this.getRequestPromise('delete', this.pushRequestPrefix + `${url}`);
    }

}